/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Page } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/reports/library/library_styles';
import PortedToBeta from "../../../../material/portedtobeta/portedtobeta";

/* ========== ~~~~~~~~~~ REPORT LIBRARY ~~~~~~~~~~ ========== */
class LibraryPage extends Component {
    render() {
        return(
            <Page name={`library`} klass={`${this.props.classes.library} processing-${this.props.isLibraryProcessing}`}>
                <PortedToBeta
                    buttonText={'Go to Reports Configuration'}
                    path={'dashboard/reportbuilder/allreports'}
                    body={<p>Reports Configuration has been moved to <b>Publisher Portal V2 (Beta)</b></p>}
                />
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(LibraryPage);
